import React from "react";
import { useNavigate } from "react-router-dom";

//
import racket from "../../../../../assets/images/racket.webp";

export default function CourseCard({ title, time, students }) {
  // router
  const navigate = useNavigate();

  //   method
  function goToUrl(url) {
    navigate(url);
  }

  return (
    <div className="courses_card" onClick={() => goToUrl("#")}>
      <div className="card_img x-bg-red ">
        <img src={racket} alt="racket" />
      </div>
      <div className="card_body">
        <h2 className="card_title">{title}</h2>
        <div className="card_info">
          <span className="card_info_item">
            <span className="bi bi-clock"></span> {time} часов
          </span>
          <span className="card_info_item">
            <span className="bi bi-people"></span> {students}
          </span>
        </div>
      </div>
    </div>
  );
}
